import styled from 'styled-components';

import { colorUsage, fontSize } from 'stylesheetB2c';

export const ElapsedAndTotalTimeContainer = styled.div`
  flex: 0;
  font-size: ${fontSize.XSmall};
  color: ${colorUsage.whiteText};
  white-space: nowrap;
`;
ElapsedAndTotalTimeContainer.displayName = 'ElapsedAndTotalTimeContainer';
